import { useState, useCallback } from 'react';
import { getEmpresas } from '../services/apiService';
import debounce from 'lodash/debounce';

export function useEmpresaSearch(configuration) {
  const [options, setOptions] = useState([]);
  const [loading, setLoading] = useState(false);

  const searchEmpresas = useCallback(
    debounce(async (inputValue) => {
      const term = inputValue?.trim() || '';

      if (term.length === 0) {
        setOptions([]);
        return;
      }

      setLoading(true);
      
      try {
        const list = await getEmpresas(configuration, term);
        const newOptions = list.map(e => ({
          value: e.id,
          label: e.nombreEmpresa,
          idEmpresa: e.idEmpresa
        }));
        
        setOptions(newOptions);
      } catch (error) {
        console.error('Error searching empresas:', error);
        setOptions([]);
      } finally {
        setLoading(false);
      }
    }, 300),
    [configuration]
  );

  return { options, loading, searchEmpresas };
}